
const tenantUtils = {

    getTenantInfo : async (accToken, tenantId, special=null) => {

        if(accToken && tenantId !== undefined) {
            let tidParam = '';
            let specObj = {};
            
            if(special){
                specObj = { "x-special-pass": `${special}` }
            }
            
            if(tenantId && (special === null || special === undefined || special === '')){
                //don't put on the tenid param if special is set
                tidParam = '?tenid='+tenantId;
            }

            let res;

            try {
                res = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/workspace${tidParam}`, {
                    headers: { 
                        "Authorization": "Bearer "+ accToken.accessToken,
                        ...specObj
                    }
                });

                return await res.json();
            } catch (error) {

                // Retry one more time if the first attempt fails 
                try {
                    res = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/workspace${tidParam}`, {
                        headers: { 
                            "Authorization": "Bearer "+ accToken.accessToken,
                            ...specObj
                        }
                    });
    
                    return await res.json();
                } catch (error) {
                    console.error('Error fetching workspace info:', error);
                    return { tenant: null, ...error };
                } 
            }
           
        }
    },

    isAdminMember : (accts) => {
        if(accts.length > 0){
            return accts[0].username.indexOf('@linksbridge.com') > -1 || accts[0].username.indexOf('@sassenach.co') > -1;
        }

        return false;
    }


}

export default tenantUtils;